export const SECTION_CODE = 'main';

export const MY_LIST_ICONS = {
  MY_LIST_ICON_BOOKED: { name: 'Check', type: ' icon' },
  MY_LIST_ICON_UNBOOKED: { name: 'Plus', type: 'icon' },
};
